
import { defineComponent, ref, onMounted, getCurrentInstance, watch, onUnmounted, computed } from 'vue';
import imgBox from '@/components/image-box/index.vue';
import { getTemplateConfig } from './template.config';

export default defineComponent({
    components: {
        imgBox,
    },
    props: {
        following: {
            type: Number,
            default: () => 0,
        },
        // 用户名称
        userName: {
            type: String,
            default: () => '',
        },
        // 头像
        headerUrl: {
            type: String,
            default: () => '',
        },
        // 描述
        description: {
            type: String,
            default: () => '',
        },
        // 音乐作者
        musicName: {
            type: String,
            default: () => '',
        },
        musicId: {
            type: Number,
            default: () => 0,
        },
        // 同框
        duet: {
            type: Boolean,
            default: false,
        },
        // 是否处于可视范围
        active: {
            type: Boolean,
            default: () => false,
        },
        photoId: {
            type: Number,
            default: () => 0,
        },
        authorId: {
            type: Number,
            default: () => 0,
        },
        kwaiId: {
            type: String,
            default: () => '',
        },
    },
    setup(props, ctx) {
        const { proxy } = getCurrentInstance() as { proxy: any };
        const headerDefault = 'https://cdn-static.kwai.net/kos/s101/nlav11312/pwa-images/header-icon.png';
        const avatar = ref(props.headerUrl);
        const showFollowedIcon = ref(false); // 设置点赞成功后的图片展示
        let timer = null as unknown;

        const handleVideoInfoClick = (type: string) => {
            ctx.emit('infoClick', { type });
        };

        const loadError = () => {
            avatar.value = headerDefault;
        };

        const origin = ref('');

        const jumpLink = computed(() => {
            return `/@${props.kwaiId}`;
        });

        onMounted(() => {
            origin.value = window.location.origin;

            watch(
                () => props.following,
                (newValue, oldValue) => {
                    if (newValue && oldValue === 0) {
                        showFollowedIcon.value = true;
                        timer = setTimeout(() => {
                            showFollowedIcon.value = false;
                        }, 1500);
                    } else {
                        showFollowedIcon.value = false;
                    }
                },
                {
                    immediate: true,
                }
            );
        });
        onUnmounted(() => {
            clearTimeout(timer as number);
        });

        return {
            avatar,
            showFollowedIcon,
            jumpLink,
            origin,
            handleVideoInfoClick,
            loadError,
            templateConfig: getTemplateConfig(),
        };
    },
});
